import { RouteObject } from 'react-router-dom';
import { ArrivalScanning } from '..';

export const ArrivalScanningRoutes: RouteObject[] = [
  {
    path: 'arrival-scanning',
    element: <ArrivalScanning />,
  },
];
